import { render, staticRenderFns } from "./RegionUsageChartCard.vue?vue&type=template&id=351e30f8&"
import script from "./RegionUsageChartCard.vue?vue&type=script&lang=ts&"
export * from "./RegionUsageChartCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports